import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseTourModel } from '../data-model/tour.model';
import { FirebasePuntoTourModel } from '../data-model/puntoTour.model';
import { FirebaseMediaElementModel } from '../data-model/mediaElement.model';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BannerComponent } from '../banner/banner.component';
import { DatabaseService } from '../services/database.service';
import { FirebaseUserModel } from '../data-model/user.model';
import * as firebase from 'firebase';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { EmbedVideoService } from 'ngx-embed-video';
import { AlertService } from '../services/alert.service';
import { throwError } from 'rxjs';

@Component({
  selector: 'app-tour-detail',
  templateUrl: './tour-detail.component.html',
  styleUrls: ['./tour-detail.component.scss']
})
export class TourDetailComponent implements OnInit, AfterViewInit {
  @ViewChild(BannerComponent) bannerData: BannerComponent; //Forma de acceder a la info de un hijo diferente a @Output (que informa todo el rato)
  bannerInitialized = false;

  @ViewChild('botonEliminar') botonEliminar: ElementRef;

  @ViewChild('search')
  public searchElementRef: ElementRef; //Forma de acceder al input de búsqueda en el mapa
  geoCoder;

  lat: number = 43.653908;
  lng: number = -79.384293;
  zoom: number = 12;

  tourData: FirebaseTourModel = null;
  tourDataOriginal: FirebaseTourModel = null;
  currentUser: firebase.User = null;

  modoVisualizacion = 'vista';
  bannerMargen = false;
  imageSanitizer = null;

  get showSelector() {
    return this.tourData != null && !this.tourData.id; //Si no hay tour o si hay tour pero no tiene id es porque está en Creación - Se muestra el Selector
  }

  puntosTour: FirebasePuntoTourModel[] = [];
  origen = null;
  destino = null;
  paradas = [];
  opcionesRender = {
    suppressMarkers: true
  }
  optimizarParadas = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private storage: StorageService,
    private sanitizer: DomSanitizer,
    private embedService: EmbedVideoService,
    private database: DatabaseService,
    private mapsAPILoader: MapsAPILoader, //Librería del mapa para hacer búsqueda
    private ngZone: NgZone, //Librería para renderizar vista de un componente de Angular
    private alert: AlertService
  ) { }

  ngAfterViewInit(): void {
    this.bannerInitialized = true;
  }

  ngOnInit(): void {
    this.initSearchbarMap();
    this.authService.getCurrentUserAlt()
      .then(data => {
        this.currentUser = data;
      })
      .catch(error => {
        this.alert.showAlert("Error", JSON.stringify(error), "error");
      });
    //Compruebo el modo de visualizacion (vista o edicion/creacion) para mostrar una interfaz u otra
    this.route.paramMap.subscribe(params => { //Guardo en params los parametros de la ruta (el id y el modo)
      if (params.get('modo') === "vista") {
        this.modoVisualizacion = 'vista';
        //Si estoy en modo edicion pero no existe, lo creo
      } else if (params.get('modo') === "edicion" || params.keys.length === 0) {
        this.modoVisualizacion = 'edicion'
      }
      if (params.get('id') === null) { //Si no obtiene id de la ruta entonces esta en modo edicion
        this.tourData = new FirebaseTourModel(); //Creo una nueva instancia
      }
      else {
        var tourId = params.get('id'); //Guardo en tourId el parametro :id de la url
        //Atento a cambios
        this.database.getTour(tourId).snapshotChanges().subscribe(data => {
          var tourInfo = data.payload.data() || undefined;
          if (tourInfo) {
            this.tourData = FirebaseTourModel.objectToModel(tourInfo);
            if (this.tourData.imageUrl != null) { //Si meto una imagen del tour
              this.imageSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(this.tourData.imageUrl); //Hago Sanitizer de la URL
            }
            if (this.modoVisualizacion == 'edicion')
              this.tourDataOriginal = FirebaseTourModel.objectToModel(tourInfo); //Hago una copia para comparar antes de guardar la edicion
            this.tourData.id = data.payload.id;
            this.puntosTour = this.tourData.puntosTour;
            this.puntosTour.forEach(puntoTour => {
              puntoTour.elementosMedia.forEach(elementoMedia => {
                elementoMedia.sanitizeUrl(this.sanitizer, this.embedService);
              });
            });
            if (this.puntosTour.length != 0) {
              this.origen = this.puntosTour[0].coord;
              if(this.puntosTour.length ==1){
                this.lat = this.puntosTour[0].coord.lat;
                this.lng = this.puntosTour[0].coord.lng;
              }
            }
            if (this.puntosTour.length > 1) {
              this.destino = this.puntosTour[(this.puntosTour.length) - 1].coord;
            }
            if (this.puntosTour.length > 2) {
              var waypoints = [];
              for (let i = 1; i < (this.puntosTour.length - 1); i++) {
                waypoints.push({ location: this.puntosTour[i].coord });
              }
              waypoints = this.paradas;
            }
          }
        });
      }
    });
  }

  initSearchbarMap() {
    this.mapsAPILoader.load().then(() => {
      //this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
  }



  showEdit() {
    return this.currentUser !== null && this.tourData !== null && this.currentUser.uid === this.tourData.uid;
  }

  onEdit() {
    this.router.navigate(['/tour/' + this.tourData.id + '/edicion']);
  }

  onCancel() {
    if (this.tourData.id != null) //Si el tour tiene id es porque existe (está en edición)
      this.router.navigate(['/tour/' + this.tourData.id + '/vista']);
    else
      this.router.navigate(['/home']);
  }

  onPublish() {
    this.database.publishTour(this.tourData.id, !this.tourData.isPublished)
      .catch(error => {
        this.alert.showAlert("Error", JSON.stringify(error), "error");
      });
  }

  onMediaElementCreated(mediaList) {
    console.log(this.puntosTour);
    mediaList.push(new FirebaseMediaElementModel());
  }

  onMediaElementDelete(mediaList, j) {
    console.log("Lista", mediaList);
    mediaList.splice(j, 1);
  }

  onPuntoTourDelete(i) {
    if (i == 0) { //Si el punto que quiero borrar es el origen
      if (this.paradas.length != 0) { //Y hay paradas
        this.origen = this.paradas[0].location; //La primera parada se convierte en origen
        this.paradas.splice(0, 1); //Quitamos la primera parada
      }
      else if (this.paradas.length = 0 && this.destino != null) { //Y no hay paradas pero hay destino
        this.origen = this.destino; //El destino se convierte en el origen
        this.destino = null; //Borro el destino
      }
      else if (this.destino == null) { //No hay destino (solo habia 1 punto)
        this.origen = null; //Borro el origen (ahora no hay ruta)
      }
    }
    else if (i > 0 && i < (this.puntosTour.length - 1)) { //Si el punto que quiero borrar es una parada (no es ni el origen ni el destino)
      this.paradas.splice(i - 1, 1); //Borro esa parada
      //Necesito crear otra lista de paradas para tener una nueva sección de memoria y que recalcule la ruta. Si no lo pongo, se borra el marker pero sigue pintando la ruta
      var paradasTemp = [];
      this.paradas.forEach(p => paradasTemp.push(p));
      this.paradas = paradasTemp;
    }
    else if (i == (this.puntosTour.length - 1)) { //Si el punto que quiero borrar es el destino
      if (this.paradas.length != 0) { //Y hay paradas
        this.destino = this.paradas[this.paradas.length - 1].location; //La última parada se convierte en destino
        this.paradas.splice(this.paradas.length - 1, 1); //Borro esa parada
      }
      else if (this.paradas.length == 0) { //Y no hay paradas
        this.destino = null; //Borro el destino
      }
    }
    console.log("Origen", this.origen, "Paradas", this.paradas, "Destino", this.destino);
    this.puntosTour.splice(i, 1); //Borra el punto y todos sus elementos media
    console.log("Puntos Tour", this.puntosTour);
  }

  onClickMap($event) {
    //Origen, Destino y Paradas es para construir la direction
    if (this.origen == null) {
      this.origen = {
        lat: $event.coords.lat,
        lng: $event.coords.lng
      };
    }
    else if (this.destino == null) {
      this.destino = {
        lat: $event.coords.lat,
        lng: $event.coords.lng
      };
    }
    else {
      this.paradas.push({ location: this.destino });
      this.destino = {
        lat: $event.coords.lat,
        lng: $event.coords.lng
      };
    }

    //puntoTour es para visualizar los markers 
    var puntoTour = new FirebasePuntoTourModel(
        'Titulo Punto' + (this.puntosTour.length + 1), 
        { lat: $event.coords.lat, lng: $event.coords.lng });
    puntoTour.elementosMedia = [
      new FirebaseMediaElementModel()
    ];
    this.puntosTour.push(puntoTour);
  }

  onResponse(event) {
    console.log("Respuesta", event);
  }

  onStatus(event) {
    console.log("Estado", event);
  }



  //Guardar en Storage la imagen del banner
  async _saveStorageBannerImage(fileName, file, uid) {
    //Necesito el user id para construir la ruta del archivo (fileLocation)
    var fileLocation = 'users/' + uid + '/' + fileName;
    //Creo una promesa para saveStorage
    //Llamo a la funcion upload del servicio storage que sube los archivos a Firebase.
    const fileUploaded = await this.storage.upload(file, fileLocation);
    //Si la promesa ha ido bien entonces devuelve info del propio archivo
    if (fileUploaded) {
      const url = await fileUploaded.ref.getDownloadURL();
      if (url) {
        this.tourData.imageUrl = url;
        this.tourData.fileLocation = fileLocation;
        this.imageSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.bannerData.imageFileName = null;
        this.bannerData.imageFile = null;
        return true;
      }
    }
  }

  async _saveBannerImage(user) {
    //para guardar la imagen del tour
    if (this.bannerData.imageFile && this.bannerData.imageFileName) {
      if (this.tourDataOriginal && this.tourDataOriginal.imageUrl) {
        await this.storage.delete(this.tourDataOriginal.fileLocation);
      }
      await this._saveStorageBannerImage(this.bannerData.imageFileName, this.bannerData.imageFile, user.uid);
    }
  }

  async _saveMediaElements(user) {
    var saveStoragePromises = [];
    //para cada elemento multimedia de cada punto del tour...
    for (let puntoTour in this.puntosTour) {
      var elementosMedia = this.puntosTour[puntoTour].elementosMedia;
      for (let elementoMedia in elementosMedia) {
        //...guarda sus archivos en el storage antes de guardar en la BBDD solo si son archivos de imagen, audio o video local
        if (( 
              elementosMedia[elementoMedia].videoType == 'local' || 
              elementosMedia[elementoMedia].type == 'audio' || 
              elementosMedia[elementoMedia].type == 'image'
            ) && 
            elementosMedia[elementoMedia].intoStorage == false) {
          saveStoragePromises.push(this.saveStorageMediaElement(elementosMedia[elementoMedia], user.uid));
        }
      }
    }
    if (saveStoragePromises.length != 0) {
      await Promise.all(saveStoragePromises) //Si todas las promesas de la lista van bien
    }
  }

  _validateTour() {
    const reasons = [];
    if (!this.bannerData.titulo) {reasons.push("El título es obligatorio")}

    if (this.bannerInitialized && this.bannerData.showSelector == true) { //Validar si hay banner
      if (!this.bannerData.selectedContinent) {reasons.push("El continente es obligatorio")}
      if (!this.bannerData.selectedCountry) {reasons.push("El país es obligatorio")}
      if (!this.bannerData.selectedCity) {reasons.push("La ciudad es obligatoria")}
    }
    if (this.puntosTour && this.puntosTour.length == 0) {reasons.push("Al menos es necesario 1 punto de ruta")}

    if(reasons && reasons.length > 0) throw reasons.join("\n");
    return true;
  }

  //Botón "Guardar" tour con puntos de ruta y elementos
  async onSave() {
    try {
      const user = await this.authService.getCurrentUserAlt();
      if (user) {
        this._validateTour();   

        await this._saveBannerImage(user);
        await this._saveMediaElements(user);
        await this._deleteOldMediaElements();

        await this.saveBBDD(); 
      }
    } catch (error) {
      this.alert.showAlert("Error",error, "error");
    }
  }

  //Guardar en Storage los archivos de cada elemento multimedia
  async saveStorageMediaElement(elementoMedia: FirebaseMediaElementModel, uid) {
    //Necesito el user id para construir la ruta del archivo (fileLocation)
    var fileLocation = 'users/' + uid + '/' + elementoMedia.fileName;
    //Creo una promesa para saveStorage
    //Llamo a la funcion upload del servicio storage que sube los archivos a Firebase.
    const file = await this.storage.upload(elementoMedia.file, fileLocation);
    //Si la promesa ha ido bien entonces devuelve info del propio archivo
    if (file) {
      const url = await file.ref.getDownloadURL()
      if (url) {
        elementoMedia.url = url;
        elementoMedia.fileLocation = fileLocation;
        elementoMedia.urlsanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        elementoMedia.intoStorage = true;
        return true;
      }
    }
    return false;
  }

  _getBannerFieldsData() {
    if (this.bannerData.showSelector == true) {
      this.tourData.continent = this.bannerData.selectedContinent;
      this.tourData.country = this.bannerData.selectedCountry;
      this.tourData.city = this.bannerData.selectedCity;
    }
    this.tourData.description = this.bannerData.descripcion;
    this.tourData.name = this.bannerData.titulo;
    //this.tourData.image=this.bannerData.imageUrl;
  }

  async saveBBDD() {
    if (this.bannerInitialized) { //Preparamos los datos para enviarlos a la BBDD
      this._getBannerFieldsData();
    }
    this.tourData.puntosTour = this.puntosTour;
    if (!this.tourData.id) { //Si el tour no tiene id significa que lo vamos a crear por 1º vez
      try {
        const user = await this.authService.getCurrentUser();
        if (user) {
          this.tourData.uid = user.uid;
          const data = await this.database.createTour(this.tourData);
          if (data) {
            this.tourData.id = data.id;
            this.alert.showAlert("Guardado", "El tour se ha guardado correctamente", "success");
            this.router.navigate(['/tour/' + this.tourData.id + '/vista']);
          }
        }
      } catch (error) {
        this.alert.showAlert("Error", JSON.stringify(error), "error");
      }
    }
    else { //Si el tour ya tiene id, significa que el usuario creador lo está editando
      this.updateTour();
    }
  }

  _getOriginalMediaElements() {
    const elementosBorrar = [];
    if(!this.tourDataOriginal) return elementosBorrar;

    this.tourDataOriginal.puntosTour.forEach(puntoTour => {
      puntoTour.elementosMedia.forEach(elementoMedia => {
        if (elementoMedia.intoStorage == true) {
          elementosBorrar.push(elementoMedia.fileLocation);
        }
      })
    });
    return elementosBorrar;
  }

  _removeRemainingMediaElements(elementosBorrar) {
    if(!elementosBorrar && elementosBorrar.length > 0)
      this.tourData.puntosTour.forEach(puntoTour => {
        puntoTour.elementosMedia.forEach(elementoMedia => {
          if (elementoMedia.intoStorage == true) {
            const index = elementosBorrar.findIndex(elemento => elemento === elementoMedia.fileLocation); //Si el elementoMedia está en la lista de elementosBorrar me devuelve su posicion en el array
            if (index >= 0) { //Lo ha encontrado (no hay que borrarlo, lo quito de la lista)
              elementosBorrar.splice(index, 1);
            }
          }
        })
      });
  }

  async _deleteOldMediaElements() {
    //Comparo la info original con la editada para borrar del storage los mediaElements
    const elementosBorrar = this._getOriginalMediaElements();
    this._removeRemainingMediaElements(elementosBorrar);

    if(!elementosBorrar || elementosBorrar.length === 0) return true;

    var elementosBorrarPromise = [];
    elementosBorrar.forEach(elementoBorrar => {
      elementosBorrarPromise.push(this.storage.delete(elementoBorrar).toPromise());
    })

    const results = await Promise.allSettled(elementosBorrarPromise);
    if (results) {
      var reasons = [];
      results.forEach(result => {
        if (result.status == 'rejected' && result.reason.code != "storage/object-not-found") {
          reasons.push(result.reason);
        }
      });
      if(reasons && reasons.length > 0) throw reasons.join('\n');
    }
  return true;
  }

  async updateTour() {
    try {
      await this.database.updateTour(this.tourData);
      this.router.navigate(['/tour/' + this.tourData.id + '/vista']);
      this.alert.showAlert("Actualizado", "El tour se ha actualizado correctamente", "success");
    } catch (error) {
      this.alert.showAlert("Error", JSON.stringify(error), "error");
    }
  }

  onModalDelete() {
    this.botonEliminar.nativeElement.click();
  }

  async onDelete() {
    try {
      await this.database.deleteTour(this.tourData.id) //El método deleteTour devuelve una promesa
      this.removeModalElements();
      this.router.navigate(['/perfil']);
      this.alert.showAlert("Eliminado", "El tour se ha eliminado correctamente", "success");
    } catch (error) {
      this.alert.showAlert("Error", JSON.stringify(error), "error");
    }
  }

  removeModalElements() {
    document.body.classList.remove('modal-open');
    const modalElement = document.body.querySelector('.modal-backdrop.fade');
    if (modalElement)
      document.body.removeChild(modalElement);
  }

}
